import { formatCalendarDate } from '../../utils/warehouseDates'
import { COVERAGE_I18N } from './i18nKeys'

// Callers pass dates the service or the period rules already proved real.
export const formatShortDate = (date, language) => formatCalendarDate(date, language, { day: 'numeric', month: 'short', year: 'numeric' })

export const formatMonth = (date, language) => {
  const month = formatCalendarDate(date, language, { month: 'long', year: 'numeric' })
  return month.charAt(0).toUpperCase() + month.slice(1)
}

export const formatCount = (value, language) => new Intl.NumberFormat(language).format(value)

const PERCENT_FRACTION_DIGITS = 1
// The smallest share the format tells apart from 0 and from 1, as a fraction (0.001 is 0.1 %).
const PERCENT_STEP = 10 ** -(PERCENT_FRACTION_DIGITS + 2)

// A share that would round to 0 % or 100 % is shown as '< 0.1 %' or '> 99.9 %', so those two read as exactly 0 or 1.
export const formatPercent = (value, language) => {
  const format = new Intl.NumberFormat(language, { style: 'percent', maximumFractionDigits: PERCENT_FRACTION_DIGITS })
  if (value > 0 && value < PERCENT_STEP / 2) return `< ${format.format(PERCENT_STEP)}`
  if (value < 1 && value >= 1 - PERCENT_STEP / 2) return `> ${format.format(1 - PERCENT_STEP)}`
  return format.format(value)
}

// The headline of a coverage: its rate and how many packed orders it is over.
export const headlineParts = ({ covered_rate, packed }, t, language) => ({
  rate: formatPercent(covered_rate, language),
  ofPacked: t(`${COVERAGE_I18N}.headline.of_packed`, { count: packed, orders: formatCount(packed, language) }),
})
